<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template><div class="k-page-wrapper">
	<h1 class="k-page-title">
		<k-btn icon large color="primary" class="mr-2" accessible-label="Return to admin main" @click="return_to_admin_main"><k-icon>fas fa-cog</k-icon></k-btn>
		Content Collections
	</h1>

	<div class="mb-3" v-show="initialized&&!new_lp">
		<div class="d-flex">
			<k-menu bottom left accessible-popover accessible-label="Create collection menu" content-id="admin-learning-progressions-create-menu"><template v-slot:activator="{on, attrs}"><k-btn v-on="on" v-bind="attrs" class="k-tight-btn" color="primary" accessible-label="Open create collection menu"><k-icon class="mr-2" small>fas fa-plus</k-icon> Create a New Collection</k-btn></template>
				<k-list min-width="250">
					<k-list-item @click="create_lp('course')"><k-list-item-icon><k-icon small>fas fa-chalkboard</k-icon></k-list-item-icon><k-list-item-title>Course</k-list-item-title></k-list-item>
					<k-list-item @click="create_lp('repo')"><k-list-item-icon><k-icon small>fas fa-diagram-project</k-icon></k-list-item-icon><k-list-item-title>Repository</k-list-item-title></k-list-item>
					<k-list-item @click="create_lp('pd')"><k-list-item-icon><k-icon small>fas fa-user-graduate</k-icon></k-list-item-icon><k-list-item-title>PD Collection</k-list-item-title></k-list-item>
				</k-list>
			</k-menu>

			<k-menu bottom left accessible-popover accessible-label="Collection options menu" content-id="admin-learning-progressions-options-menu"><template v-slot:activator="{on, attrs}"><k-btn v-on="on" v-bind="attrs" class="k-tight-btn ml-2" color="primary" accessible-label="Open collection options menu"><k-icon class="mr-2" small>fas fa-gear</k-icon> More Options...</k-btn></template>
				<k-list min-width="250">
					<k-list-item @click="duplicate_lp"><k-list-item-icon><k-icon small>fas fa-copy</k-icon></k-list-item-icon><k-list-item-title>Duplicate an Existing Collection</k-list-item-title></k-list-item>
					<k-list-item v-if="site_config.enable_subdomain_collection_copy" @click="show_copy_to_subdomain_dialog"><k-list-item-icon><k-icon small>fas fa-share-nodes</k-icon></k-list-item-icon><k-list-item-title>Copy Collection to Subdomain</k-list-item-title></k-list-item>
					<k-list-item @click="delete_lp_clicked"><k-list-item-icon><k-icon small>fas fa-trash-alt</k-icon></k-list-item-icon><k-list-item-title>Delete an Existing Collection</k-list-item-title></k-list-item>
					<k-list-item @click="show_change_collection_type_dialog"><k-list-item-icon><k-icon small>fas fa-shuffle</k-icon></k-list-item-icon><k-list-item-title>Change a Collection’s Type</k-list-item-title></k-list-item>
					<k-list-item @click="show_subject_color_changer = true"><k-list-item-icon><k-icon small>fas fa-square-check</k-icon></k-list-item-icon><k-list-item-title>Update Subject Colors</k-list-item-title></k-list-item>
				</k-list>
			</k-menu>

			<k-spacer/>

			<!-- <k-btn small color="secondary" class="mr-2" @click="go_to('classes')">Go to Courses<k-icon small class="ml-2">fas fa-circle-arrow-right</k-icon></k-btn>
			<k-btn small color="secondary" @click="go_to('resourcerepos')">Go to Repos<k-icon small class="ml-2">fas fa-circle-arrow-right</k-icon></k-btn> -->
		</div>

		<k-dialog v-model="change_collection_type_dialog_showing" max-width="680" persistent scrollable>
			<k-card>
				<k-card-title><b>Change Collection Type</b></k-card-title>
				<k-card-text class="pt-2 pb-4" style="border-top:1px solid #999;">
					<div class="pt-2">
						<k-autocomplete clearable v-model="selected_collection" :items="course_selection_array" label="Choose a Collection" outlined hide-details dense background-color="#fff" @change="">
						</k-autocomplete>
					</div>
					<k-expand-transition>
						<div class="mt-4" v-if="selected_collection">
							<!-- <pre>{{ JSON.stringify(selected_collection, false, 2) }}</pre> -->
							<k-autocomplete :items="collection_types" v-model="updated_collection_type" return-object :label="collection_select_label" outlined hide-details dense background-color="#fff"></k-autocomplete>
						</div>
					</k-expand-transition>
				</k-card-text>
				<k-card-actions class="pl-4 pr-4 pb-4" >
					<k-spacer/>
					<k-btn color="primary" @click="save_collection_type_change" :disabled="!change_collection_type_saveable"><k-icon small class="mr-2">fas fa-save</k-icon>Save</k-btn>
					<k-btn color="secondary" @click="change_collection_type_dialog_showing=false"><k-icon small class="mr-2">fas fa-times</k-icon>Cancel</k-btn>
				</k-card-actions>
			</k-card>
		</k-dialog>

		<k-dialog v-if="site_config.enable_subdomain_collection_copy" v-model="copy_to_subdomain.dialog_showing" max-width="600" persistent scrollable>
			<k-card>
				<k-card-title><b>Copy Collection to Subdomain</b></k-card-title>
				<k-card-text class="pt-2 pb-4" style="border-top:1px solid #999;">
					<div class="pt-2">
						<k-autocomplete clearable v-model="copy_to_subdomain.source" :items="course_selection_array" label="Source Collection" outlined hide-details dense background-color="#fff"></k-autocomplete>
					</div>
					<div class="mt-4">
						<k-autocomplete clearable v-model="copy_to_subdomain.agency" :items="copy_to_subdomain_agency_items" label="Target Subdomain" outlined hide-details dense background-color="#fff" :loading="copy_to_subdomain.agencies_loading" no-data-text="No subdomains found"></k-autocomplete>
					</div>
					<div class="mt-4">
						<k-radio-group v-model="copy_to_subdomain.mode" row hide-details>
							<k-radio value="structure_only" label="Copy folder structure only"></k-radio>
							<k-radio value="all_items" label="Copy all items"></k-radio>
						</k-radio-group>
					</div>
				</k-card-text>
				<k-card-actions class="pl-4 pr-4 pb-4">
					<k-spacer/>
					<k-btn color="secondary" @click="copy_to_subdomain.dialog_showing = false"><k-icon small class="mr-2">fas fa-times</k-icon>Cancel</k-btn>
					<k-btn color="primary" @click="confirm_copy_to_subdomain" :disabled="!copy_to_subdomain_saveable"><k-icon small class="mr-2">fas fa-share-nodes</k-icon>Copy</k-btn>
				</k-card-actions>
			</k-card>
		</k-dialog>
	</div>

	<CollectionEdit v-if="new_lp" :learning_progression="new_lp" @editor_cancel="new_lp=null"></CollectionEdit>
	<CollectionEdit v-if="show_editor_for_changed_collection" :learning_progression="selected_collection" @editor_cancel="close_editor_for_changed_collection"></CollectionEdit>
	<AdminSubjectChanger v-if="show_subject_color_changer" @dialog_cancel="show_subject_color_changer=false"/>
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'
import CollectionEdit from '../collections/CollectionEdit'
import AdminSubjectChanger from './AdminSubjectChanger.vue';

export default {
	components: { CollectionEdit, AdminSubjectChanger },
	
	data() { return {
		initialized: false,
		new_lp: null,
		selected_collection: '',
		change_collection_type_dialog_showing: null,
		updated_collection_type: null,
		show_editor_for_changed_collection: false,
		collection_types: [
			{ text: 'Course Collection', value: 'course'},
			{ text: 'Resource Repository', value: 'repo' },
			{ text: 'PD Collection', value: 'pd' },
			{ text: 'User Collection', value: 'my'},
		],
		show_subject_color_changer: false,
		copy_to_subdomain: {
			dialog_showing: false,
			source: null,
			agency: null,
			mode: 'structure_only',
			agencies: null,
			agencies_loading: false,
		},
	}},

	computed: {
		...mapState(['user_info', 'site_config', 'all_courses_loaded', 'all_courses', 'added_my_courses', 'lst']),
		...mapGetters([]),

		copy_to_subdomain_agency_items() {
			if (!this.copy_to_subdomain.agencies) return []
			return this.copy_to_subdomain.agencies
				.filter(a => a.subdomain)
				.map(a => ({ value: a, text: `${a.agency_name} (${a.subdomain})` }))
		},

		copy_to_subdomain_saveable() {
			return !!(this.copy_to_subdomain.source && this.copy_to_subdomain.agency)
		},

		collection_select_label() {
			if (!this.change_collection_type_dialog_showing || !this.updated_collection_type) return ''
			return this.updated_collection_type.value === this.selected_collection.collection_type ? 'Current collection type' : 'Update collection type to'
		},

		course_selection_array() {
			let arr = []
			for (let lp of this.all_courses) {
				// skip inactive courses if user isn't an admin for the course
				if (lp.active != 'yes' && !(lp.user_can_view_lp && lp.user_can_view_lp())) continue

				// Skip the My Content Sandbox collection
				if (lp.course_code === 'default') continue

				arr.push({value:lp, text: lp.title})
			}

			// Sort on various parameters
			let priority_collections = []
			let added_courses = new Set()
			// 1st priority is the last viewed collections
			priority_collections.push(...arr.filter( ({value}) => {
				const exists = this.lst.last_collections_viewed.includes(`${value.course_code}`)
				if (exists && !added_courses.has(value.course_code)) {
					added_courses.add(value.course_code)
					return exists
				}
			}))
			// 2nd priority is the user created
			priority_collections.push(...arr.filter( ({value}) => {
				const exists = this.user_info.admin_rights.includes(`lp.course.${value.course_code}`)
				if (exists && !added_courses.has(value.course_code)) {
					added_courses.add(value.course_code)
					return exists
				}
			}))
			// 3rd priority is the added my courses
			priority_collections.push(...arr.filter( ({value}) => {
				const exists = this.added_my_courses.includes(`${value.course_code}`)
				if (exists && !added_courses.has(value.course_code)) {
					added_courses.add(value.course_code)
					return exists
				}
			}))
			const non_priority = arr.filter((e) => !priority_collections.includes(e))
			// sort alphabetically
			non_priority.sort((a,b)=>U.natural_sort(a.value.title, b.value.title))

			return [...priority_collections, ...non_priority]
		},

		selected_collection_title() {
			return this.selected_collection?.title
		},

		change_collection_type_saveable() {
			if (!this.selected_collection) return false
			return this.selected_collection.collection_type !== this.updated_collection_type.value
		},
	},

	created() {
		if (!this.all_courses_loaded) {
			this.$store.dispatch('get_all_courses').then(()=>{
				this.$nextTick(()=>{
					this.initialized = true
				})
			}).catch(()=>{
				this.$alert('error in get_all_courses')
				this.return_to_admin_main()
			})
		} else {
			this.initialized = true
		}
	},
	
	watch: {
		selected_collection(new_val) {
			const collection_type = new_val?.collection_type ?? null
			if (!collection_type) return
			this.updated_collection_type = this.collection_types.find(item => item.value === collection_type)
		},
	},
	
	methods: {
		create_lp(collection_type) {
			// lps created from here are definitionally agency_sanctioned
			this.new_lp = new Learning_Progression({agency_sanctioned: true, collection_type: collection_type})
			return
		},

		duplicate_lp() {
			this.$prompt({
				title: 'Duplicate Collection',
				text: 'Enter the “course code(s)” for the collection (course or repository) you’d like to duplicate, along with the new course codes for the duplicates. Separate each original and duplicate course code with a :, and separate multiple course code pairs with a line break, like this:<br><br>1111: 1112<br>3333: 3334<br>5555: 5556<br><br>',
				promptType: 'textarea',
				acceptText: 'Duplicate',
			}).then(course_code_lines => {
				if (empty(course_code_lines)) return
				course_code_lines = $.trim(course_code_lines).split(/\n+/)

				// parse lines and check for errors
				let course_codes = []
				let bad_origin_course_codes = []
				let bad_destination_course_codes = []
				for (let line of course_code_lines) {
					let arr = $.trim(line).split(/[\s\:]+/)
					if (arr.length != 2) {
						this.$alert('Bad line in input:<br><br>' + line)
						return
					}

					// if the first code doesn't exist, error
					if (empty(this.$store.state.all_courses.find((o)=>o.course_code==arr[0]))) {
						bad_origin_course_codes.push(arr[0])
					}

					// if the second code does exist, error
					if (!empty(this.$store.state.all_courses.find((o)=>o.course_code==arr[1]))) {
						bad_destination_course_codes.push(arr[1])
					}

					course_codes.push(arr)
				}

				if (bad_origin_course_codes.length > 0) {
					this.$alert(sr('We don’t have collection(s) for course code(s) $1. Operation cancelled.', bad_origin_course_codes.join(', ')))
					return
				}
				if (bad_destination_course_codes.length > 0) {
					this.$alert(sr('We already have collection(s) for course code(s) $1. Operation cancelled.', bad_destination_course_codes.join(', ')))
					return
				}

				// if we get to here, process the duplicates
				this.$store.dispatch('duplicate_learning_progressions', course_codes).then(()=>{
					this.$alert('Collection(s) duplicated.')
				})
			}).catch(n => {console.error(n)})
		},

		delete_lp_clicked() {
			this.$prompt({
				title: 'Delete Collection',
				text: 'Enter the “course code” for the collection you’d like to delete.',
				acceptText: 'Delete',
				acceptColor: 'red',
			}).then(course_code => {
				if (!empty(course_code)) {
					this.delete_lp(course_code)
				}
			}).catch(n => {console.error(n)})
		},

		delete_lp(course_code) {
			let lp = this.$store.state.all_courses.find((o)=>o.course_code==course_code)
			if (empty(lp)) {
				this.$alert('We don’t have a collection for that course code in the system.')
				return
			}

			this.$confirm({
				title: 'Are you sure?',
				text: sr('Are you sure you want to delete the collection for course code $1 (“$2”)?', lp.course_code, lp.title),
				acceptText: 'Delete',
				acceptColor: 'red',
			}).then(() => {
				this.$store.dispatch('delete_learning_progression', lp).then(()=>{
					this.$alert('Collection deleted.')
				})
			}).catch(n => {console.error(n)})
		},

		show_copy_to_subdomain_dialog() {
			Object.assign(this.copy_to_subdomain, {
				dialog_showing: true,
				source: null,
				agency: null,
				mode: 'structure_only',
			})

			if (!this.copy_to_subdomain.agencies) {
				this.copy_to_subdomain.agencies_loading = true
				U.ajax('admin_manage_agencies', { user_id: this.user_info.user_id }, result => {
					this.copy_to_subdomain.agencies_loading = false
					if (result.status != 'ok') { vapp.ping(); return }
					this.copy_to_subdomain.agencies = result.agencies
				})
			}
		},

		confirm_copy_to_subdomain() {
			const agency = this.copy_to_subdomain.agency
			this.$store.dispatch('copy_collection_to_subdomain', {
				source_course_code: this.copy_to_subdomain.source.course_code,
				agency_id: agency.agency_id,
				copy_items: this.copy_to_subdomain.mode === 'all_items',
			}).then(() => {
				this.copy_to_subdomain.dialog_showing = false
				this.$alert(sr('Collection copied to the "$1" subdomain.', agency.subdomain))
			}).catch(n => { console.error(n) })
		},

		return_to_admin_main() {
			this.$router.push({ path: '/' })
		},

		show_change_collection_type_dialog() {
			this.change_collection_type_dialog_showing = true
			this.selected_collection = null
		},

		save_collection_type_change() {
			const collection_type = this.selected_collection?.collection_type
			const previous_collection_type = this.collection_types.find(item => item.value === collection_type).text || `${collection_type} collection`

			let confirm_prompt = `Are you sure you want to change the collection type for "${this.selected_collection.title}" from ${previous_collection_type} to ${this.updated_collection_type.text}?`

			// Switching from another collection type to a 'My' collection is worth an extra warning
			if (this.updated_collection_type.value === 'my') confirm_prompt += ` Switching from a ${previous_collection_type} to a User Collection might have unintended consequences.`

			this.$confirm({
				title: 'Are you sure?',
				text: confirm_prompt,
			}).then(() => {
				const payload = {
					course_code: this.selected_collection.course_code,
					updated_collection_type: this.updated_collection_type.value
				}
				this.$store.dispatch('admin_change_collection_type', payload).then(()=>{
					this.change_collection_type_dialog_showing = false

					// If we have changed to a Course Collection, we need to add required course data (subject & grade)
					if (this.updated_collection_type.value === 'course') {
						this.show_editor_for_changed_collection = true
						this.$inform('Please set course subject and grade range')
					} else {
						this.selected_collection = null
						this.$alert('Collection type changed.')
					}

				})
			}).catch(n => {console.error(n)})
		},

		close_editor_for_changed_collection() {
			this.selected_collection = null
			this.show_editor_for_changed_collection = false
		},

		go_to(where) {
			vapp.go_to_home(where)
		},
	}
}
</script>

<style lang="scss">
</style>
